/* The September customer-page design, backed by Shopify Customer Account API. */
(() => {
  const text = (key, values) => window.PlaygeniI18n?.text('account.' + key, values) || '';
  const root = document.querySelector('[data-pg-account]');
  if (!root || !window.PGAccountAPI) return;
  const q = selector => root.querySelector(selector);
  const designPreview = root.dataset.designPreview === 'true';
  const api = window.PGAccountAPI.create({
    clientId:root.dataset.clientId, shopDomain:root.dataset.shopDomain, storeRoot:root.dataset.storeRoot, hostedLoginUrl:root.dataset.hostedLoginUrl,
    callbackUrl:new URL(root.dataset.accountPath, location.origin).href, locale:root.dataset.locale || 'en',
  });
  const profileForm = q('[data-account-profile-form]'), addressForm = q('[data-account-address-form]');
  let savedName = {}, marketingState = 'UNSUBSCRIBED';
  const normalizeName = value => value.trim().replace(/\s+/g,' ');
  function updateNameSave() {
    q('[data-account-save-name]').hidden = normalizeName(profileForm.elements.fullName.value) === normalizeName([savedName.firstName,savedName.lastName].filter(Boolean).join(' '));
  }
  profileForm.elements.fullName.addEventListener('input', updateNameSave);
  profileForm.elements.fullName.addEventListener('change', updateNameSave);
  let detailVersion = 0;
  let addresses = [], defaultId, editingId = null, orderCursor, addressCursor, version = 0;
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text != null) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  function message(text, error = false) {
    const target = q(error ? '[data-account-error]' : '[data-account-status]');
    target.textContent = text; target.hidden = !text;
    if (error && text) { target.tabIndex = -1; target.focus(); }
  }
  function clearMessages() { message(''); message('', true); }
  function signedOut() {
    version++; detailVersion++;
    q('[data-account-order-detail]').replaceChildren(); q('[data-account-order-actions]').replaceChildren();
    q('#AccountOrderTitle').textContent = text('order_details_html'); q('[data-account-order-breadcrumb]').textContent = text('order_details_html');
    q('[data-account-workspace]').hidden = true; q('[data-account-login]').hidden = !designPreview;
    q('[data-account-transition]').hidden = designPreview;
    profileForm.reset(); savedName = {}; updateNameSave(); addressForm.reset(); addresses = []; defaultId = null;
    q('[data-account-email]').value = ''; q('[data-account-marketing]').setAttribute('aria-checked','false'); q('[data-account-greeting]').textContent = '';
    q('[data-account-orders]').replaceChildren(); q('[data-account-addresses]').replaceChildren();
    q('[data-account-address-editor]').hidden = true;
  }
  function fail(error) {
    if (error.signInRequired) signedOut();
    if (!designPreview && q('[data-account-workspace]').hidden) {
      q('[data-account-transition]').hidden = false;
      q('[data-account-transition-status]').hidden = true;
      q('[data-account-sign-in-retry]').hidden = false;
    }
    message(error.message || text('error_html'), true);
    if (error.retry && !error.signInRequired) {
      const retry = node('button', text('retry_html')); retry.type = 'button'; retry.dataset.accountRetry = '';
      retry.addEventListener('click', () => action(retry, error.retry)); q('[data-account-error]').append(' ', retry);
    }
  }
  async function action(element, work, success) {
    if (root.dataset.busy === 'true') return;
    clearMessages(); root.dataset.busy = 'true'; element.setAttribute('aria-busy', 'true');
    const controls = [...root.querySelectorAll('button,input,select')].filter(control => !control.disabled);
    controls.forEach(control => { control.disabled = true; });
    let focusAfter;
    try { focusAfter = await work(); if (success) message(success); }
    catch (error) { fail(error); }
    finally { controls.forEach(control => { control.disabled = false; }); element.removeAttribute('aria-busy'); delete root.dataset.busy; focusAfter?.focus?.(); }
  }
  let renderedRoute;
  function panel(name, focus = false) {
    renderedRoute = name;
    const requestId = ++detailVersion;
    const selected = name.startsWith('order/') ? 'order' : name === 'details' ? 'details' : 'orders';
    root.querySelectorAll('[data-account-panel]').forEach(el => { el.hidden = el.dataset.accountPanel !== selected; });
    root.querySelectorAll('[data-account-tab]').forEach(el => {
      if (el.dataset.accountTab === (selected === 'order' ? 'orders' : selected)) el.setAttribute('aria-current', 'page');
      else el.removeAttribute('aria-current');
    });
    if (selected === 'order' && !q('[data-account-workspace]').hidden) {
      let id; try { id = decodeURIComponent(name.slice(6)); } catch { id = ''; }
      showOrder(id, requestId, focus);
    } else if (focus) q(`[data-account-panel="${selected}"] h2`).focus();
  }
  function navigatePanel(name) {
    history.pushState(null, '', '#'+name); panel(name, true);
  }
  root.querySelectorAll('[data-account-tab]').forEach(link => link.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); navigatePanel(link.dataset.accountTab);
  }));
  root.addEventListener('click', event => {
    const link = event.target.closest('[data-account-route]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); navigatePanel(link.dataset.accountRoute);
  });
  window.addEventListener('popstate', () => panel(location.hash.slice(1), true));
  window.addEventListener('hashchange', () => {
    if (renderedRoute !== location.hash.slice(1)) panel(location.hash.slice(1), true);
  });
  function fillProfile(profile) {
    if (!profile) throw Object.assign(new Error(text('sign_in_again_html')), {signInRequired:true});
    savedName = {firstName:profile.firstName || '',lastName:profile.lastName || ''};
    profileForm.elements.fullName.value = [savedName.firstName,savedName.lastName].filter(Boolean).join(' ');
    updateNameSave();
    q('[data-account-email]').value = profile.emailAddress?.emailAddress || '';
    renderMarketing(profile.emailAddress?.marketingState || 'UNSUBSCRIBED');
    q('[data-account-greeting]').textContent = profile.firstName ? text('welcome_named_html', {name:profile.firstName}) : text('welcome_html');
  }
  function renderMarketing(state) {
    marketingState = state;
    q('[data-account-marketing]').setAttribute('aria-checked', String(state === 'SUBSCRIBED' || state === 'PENDING'));
    q('[data-account-marketing-note]').hidden = state !== 'PENDING';
    q('[data-account-marketing-note]').textContent = state === 'PENDING' ? text('marketing_pending_html') : '';
  }
  const readable = value => text('status_' + String(value || '').toLowerCase() + '_html') || text('unknown_html');
  function money(price) {
    if (!price) return '';
    try { return new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:price.currencyCode}).format(Number(price.amount)); }
    catch { return `${price.amount} ${price.currencyCode}`; }
  }
  function safeURL(value) {
    if (!value) return null;
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' || url.origin === location.origin ? url.href : null; } catch { return null; }
  }
  function orderBadge(order) {
    const state = order.cancelledAt ? 'CANCELLED' : order.financialStatus;
    const badge = node('span', readable(state), 'pg-account-order-status');
    badge.dataset.status = state || ''; return badge;
  }
  function orderMetadata(order) {
    const meta = node('div',null,'pg-account-order-meta');
    if (order.processedAt) {
      const date = new Date(order.processedAt);
      if (!Number.isNaN(date.getTime())) meta.append(node('p',text('order_placed_html', {date:new Intl.DateTimeFormat(root.dataset.locale || 'en',{year:'numeric',month:'long',day:'numeric'}).format(date)})));
    }
    meta.append(node('p',text('payment_status_html', {status:readable(order.financialStatus)})));
    return meta;
  }
  function buyAgain(order) {
    if (!api.canReorder(order)) return null;
    const buy = node('button',text('buy_again_html'),'pg-account-button pg-account-outline pg-account-small');
    buy.type = 'button'; buy.dataset.accountBuyAgain = '';
    buy.addEventListener('click', () => action(buy, () => api.reorder(order))); return buy;
  }
  function orderLine(item, details = false) {
    const line = node('div',null,'pg-account-order-line'), imageURL = safeURL(item.image?.url);
    if (imageURL) { const img = node('img',null,'pg-account-product-image');img.src = imageURL;img.alt = item.image?.altText || '';img.width = 58;img.height = 58;img.loading = 'lazy';line.append(img); }
    const info = node('div',null,'pg-account-product-info');info.append(node('p',item.name || item.title));
    const description = [item.productType, details ? item.sku : null].filter(Boolean).join(' · ');
    if (description) info.append(node('p',description));
    line.append(info,node('span',`x${item.quantity}`,'pg-account-product-quantity'),node('span',money(item.totalPrice),'pg-account-product-price'));
    return line;
  }
  function orderTotals(order) {
    const totals = node('dl',null,'pg-account-order-totals');
    const rows = [['subtotal',order.subtotal],['shipping',order.totalShipping],['tax',order.totalTax],['duties',order.totalDuties],['tip',order.totalTip],['total',order.totalPrice],['refunded',order.totalRefunded]];
    for (const [label,price] of rows) {
      if (!price || (!['subtotal','shipping','total'].includes(label) && !(Number(price.amount) > 0))) continue;
      const row = node('div',null,label === 'total' ? 'pg-account-order-total' : 'pg-account-order-totals-row');
      row.append(node('dt',text(label + '_html')),node('dd',money(price)));totals.append(row);
    }
    return totals;
  }
  async function loadOrders(more = false) {
    const current = version, data = await api.orders(more ? orderCursor : null);
    if (current !== version) return;
    const list = q('[data-account-orders]');
    if (!more) list.replaceChildren();
    if (!more && !data.nodes.length) list.append(q('[data-account-empty-orders]').content.cloneNode(true));
    for (const order of data.nodes) {
      const row = node('article',null,'pg-account-order'), overview = node('div',null,'pg-account-order-overview');
      const summary = node('div'), heading = node('div',null,'pg-account-order-heading');
      heading.append(node('h3',text('order_named_html', {name:order.name})),orderBadge(order));summary.append(heading,orderMetadata(order));overview.append(summary);
      const links = node('div',null,'pg-account-order-links');
      const detail = node('a',text('order_link_html'),'pg-account-button pg-account-small');detail.dataset.accountRoute = 'order/'+encodeURIComponent(order.id);detail.href = '#'+detail.dataset.accountRoute;
      detail.setAttribute('aria-label',text('order_link_label_html', {name:order.name}));links.append(detail);
      const buy = buyAgain(order);if (buy) links.append(buy);overview.append(links);
      const items = node('div',null,'pg-account-order-items');
      for (const item of order.lineItems?.nodes || []) items.append(orderLine(item));
      if (order.lineItems?.pageInfo?.hasNextPage) items.append(node('p',text('open_details_html')));
      items.append(orderTotals(order));row.append(overview,items);list.append(row);
    }
    orderCursor = data.pageInfo.endCursor;
    q('[data-account-more-orders]').hidden = !data.pageInfo.hasNextPage;
  }
  async function showOrder(id, requestId, focus) {
    const current = version, content = q('[data-account-order-detail]'), title = q('#AccountOrderTitle'), actions = q('[data-account-order-actions]');
    const active = () => current === version && requestId === detailVersion;
    content.replaceChildren(); actions.replaceChildren();title.textContent = text('order_details_html');q('[data-account-order-breadcrumb]').textContent = text('order_details_html');
    const loading = node('p',text('loading_order_html'),'pg-account-order-loading');loading.setAttribute('role','status');content.append(loading);
    if (focus) title.focus();
    try {
      if (!id) throw new Error(text('order_unavailable_html'));
      let order = await api.order(id);
      if (!active()) return;
      title.textContent = text('order_named_html', {name:order.name});q('[data-account-order-breadcrumb]').textContent = text('order_named_html', {name:order.name});
      const grid = node('div',null,'pg-account-order-detail-grid'), itemsCard = node('div',null,'pg-account-order-detail-items');
      const items = node('div',null,'pg-account-order-items');
      for (const item of order.lineItems?.nodes || []) items.append(orderLine(item,true));
      itemsCard.append(items,orderTotals(order));
      const sidebar = node('aside',null,'pg-account-order-summary');sidebar.setAttribute('aria-label',text('order_information_html'));
      const status = node('div',null,'pg-account-order-heading');status.append(node('span',text('status_html')),orderBadge(order));sidebar.append(status,orderMetadata(order));
      for (const [label,address] of [[text('billing_address_html'),order.billingAddress],[text('shipping_address_html'),order.shippingAddress]]) {
        const section = node('section');section.append(node('h3',label));const block = node('address');
        const lines = address?.formatted?.filter(Boolean) || [];
        if (lines.length) for (const line of lines) block.append(node('p',line));
        else block.append(node('p',text('no_address_html')));
        section.append(block);sidebar.append(section);
      }
      grid.append(itemsCard,sidebar);content.replaceChildren(grid);
      const updateBuy = () => { actions.replaceChildren();const buy = buyAgain(order);if (buy) actions.append(buy); };
      updateBuy();
      const more = node('button',text('more_items_html'),'pg-account-button pg-account-outline pg-account-small');more.type = 'button';more.hidden = !order.lineItems?.pageInfo?.hasNextPage;
      itemsCard.append(more);
      more.addEventListener('click',async () => {
        if (more.disabled) return;
        more.disabled = true;more.setAttribute('aria-busy','true');
        itemsCard.querySelector('[data-order-item-error]')?.remove();
        try {
          const next = await api.order(id,order.lineItems.pageInfo.endCursor);
          if (!active()) return;
          for (const item of next.lineItems.nodes) items.append(orderLine(item,true));
          order = {...order,lineItems:{nodes:[...order.lineItems.nodes,...next.lineItems.nodes],pageInfo:next.lineItems.pageInfo}};
          more.hidden = !next.lineItems.pageInfo.hasNextPage;updateBuy();
          if (more.hidden) title.focus();
        } catch (error) {
          if (!active()) return;
          if (error.signInRequired) { fail(error);return; }
          const warning = node('p',error.message || text('items_error_html'));warning.dataset.orderItemError = '';warning.setAttribute('role','alert');itemsCard.append(warning);
        } finally { more.disabled = false;more.removeAttribute('aria-busy'); }
      });
    } catch (error) {
      if (!active()) return;
      if (error.signInRequired) { fail(error);return; }
      const warning = node('p',error.message || text('order_error_html'));warning.setAttribute('role','alert');
      const retry = node('button',text('retry_html'),'pg-account-button pg-account-outline pg-account-small');retry.type = 'button';retry.addEventListener('click',()=>showOrder(id,++detailVersion,true));
      content.replaceChildren(warning,retry);
    }
  }
  function addressButton(label, attribute, id) {
    const button = node('button', label); button.type = 'button'; button.setAttribute(attribute, id); return button;
  }
  function renderAddresses() {
    const list = q('[data-account-addresses]'); list.replaceChildren();
    if (!addresses.length) { list.append(node('p', text('empty_addresses_html'))); return; }
    for (const address of addresses) {
      const row = node('article', null, 'pg-account-address'), description = node('div',null,'pg-account-address-description');
      const pin = node('img');pin.src = root.dataset.iconPin;pin.alt = '';pin.width = 24;pin.height = 24;description.append(pin);
      const summary = [address.address1,address.address2,address.city,[address.zoneCode,address.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      description.append(node('p',summary || address.formatted?.join(', ') || text('saved_address_html')));
      if (address.id === defaultId) {
        description.append(node('span',text('default_html'),'pg-account-default'));
        description.append(node('p',text('default_address_delete_hint_html'),'pg-account-address-hint'));
      }
      const actions = node('div',null,'pg-account-address-actions');
      for (const [name,label] of [['edit',text('edit_html')],['delete',text('delete_html')]]) {
        const button = addressButton('',`data-address-${name}`,address.id);button.className = 'pg-account-icon-button';button.setAttribute('aria-label',text(name === 'edit' ? 'edit_address_label_html' : 'delete_address_label_html', {address:summary}));button.title = label;
        if (name === 'delete' && address.id === defaultId) { button.disabled = true; button.title = text('default_address_delete_hint_html'); }
        const icon = node('img');icon.src = root.dataset[name === 'edit' ? 'iconEdit' : 'iconDelete'];icon.alt = '';icon.width = 20;icon.height = 20;button.append(icon);actions.append(button);
      }
      row.append(description,actions);list.append(row);
    }
  }
  async function loadAddresses(more = false) {
    const current = version, data = await api.addresses(more ? addressCursor : null);
    if (current !== version) return;
    addresses = more ? [...addresses,...data.addresses.nodes] : data.addresses.nodes;
    defaultId = data.defaultAddress?.id; addressCursor = data.addresses.pageInfo.endCursor;
    renderAddresses(); q('[data-account-more-addresses]').hidden = !data.addresses.pageInfo.hasNextPage;
  }
  async function refreshAddressesAfterSave() {
    try { await loadAddresses(); }
    catch (error) {
      if (!error.signInRequired) { error.message = text('address_refresh_error_html'); error.retry = refreshAddressesAfterSave; }
      throw error;
    }
  }
  async function loadAccount() {
    const current = version; message(text('loading_account_html'));
    const results = await Promise.allSettled([api.profile(), loadOrders(), loadAddresses()]);
    if (current !== version) return;
    message('');
    if (results[0].status === 'fulfilled') {
      fillProfile(results[0].value); q('[data-account-login]').hidden = true; q('[data-account-transition]').hidden = true; q('[data-account-workspace]').hidden = false;
      panel(location.hash.slice(1));
    }
    const failure = results.find(result => result.status === 'rejected');
    if (failure) {
      const expired = results.find(result => result.status === 'rejected' && result.reason.signInRequired);
      fail((expired || failure).reason);
      if (!expired) {
        const retry = node('button', text('retry_html')); retry.type = 'button'; retry.dataset.accountRetry = '';
        retry.addEventListener('click', () => action(retry, loadAccount)); q('[data-account-error]').append(' ', retry);
      }
    }
  }
  // Country names use the visitor’s locale, while Shopify receives ISO codes.
  const countryCodes = 'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
  let displayNames; try { displayNames = new Intl.DisplayNames([root.dataset.locale || 'en'], {type:'region'}); } catch { /* ISO codes remain usable. */ }
  const countrySelect = addressForm.elements.territoryCode;
  const placeholder = node('option', text('choose_country_html')); placeholder.value = ''; countrySelect.append(placeholder);
  countryCodes.map(code => ({code,name:displayNames?.of(code) || code})).sort((a,b) => a.name.localeCompare(b.name)).forEach(({code,name}) => { const option = node('option',name); option.value = code; countrySelect.append(option); });
  function editAddress(id = null) {
    if (root.dataset.busy) return;
    clearMessages(); editingId = id; addressForm.reset();
    const address = addresses.find(item => item.id === id);
    if (address) for (const field of addressForm.elements) { if (field.name && field.name !== 'defaultAddress') field.value = address[field.name] || ''; }
    addressForm.elements.defaultAddress.checked = Boolean(id && id === defaultId);
    q('#AddressEditorTitle').textContent = id ? text('edit_address_html') : text('add_address_html');
    q('[data-account-address-editor]').hidden = false; q('#AddressEditorTitle').focus();
  }
  const addressInput = address => Object.fromEntries(['firstName','lastName','company','address1','address2','city','territoryCode','zoneCode','zip','phoneNumber'].map(key => [key,address[key] || '']));
  q('[data-account-add-address]').addEventListener('click', () => editAddress());
  q('[data-account-cancel-address]').addEventListener('click', () => { q('[data-account-address-editor]').hidden = true; editingId = null; q('[data-account-add-address]').focus(); });
  q('[data-account-addresses]').addEventListener('click', event => {
    const button = event.target.closest('button'); if (!button) return;
    if (button.hasAttribute('data-address-edit')) { editAddress(button.dataset.addressEdit); return; }
    const id = button.dataset.addressDelete || button.dataset.addressDefault;
    if (button.hasAttribute('data-address-delete') && window.confirm(text('delete_address_confirm_html'))) action(button, async () => {
      await api.deleteAddress(id); q('[data-account-address-editor]').hidden = true; addresses = addresses.filter(address => address.id !== id); renderAddresses(); await refreshAddressesAfterSave(); return q('[data-account-add-address]');
    }, text('address_deleted_html'));
    else if (button.hasAttribute('data-address-default')) action(button, async () => {
      await api.saveAddress(id, addressInput(addresses.find(address => address.id === id)), true); await refreshAddressesAfterSave();
    }, text('default_address_updated_html'));
  });
  addressForm.addEventListener('submit', event => {
    event.preventDefault();
    const data = addressInput(Object.fromEntries(new FormData(addressForm))), primary = addressForm.elements.defaultAddress.checked;
    action(addressForm, async () => { await api.saveAddress(editingId,data,primary); q('[data-account-address-editor]').hidden = true; editingId = null; await refreshAddressesAfterSave(); return q('[data-account-add-address]'); }, text('address_saved_html'));
  });
  profileForm.addEventListener('submit', event => {
    event.preventDefault();
    updateNameSave();
    if (q('[data-account-save-name]').hidden) return;
    const fullName = normalizeName(profileForm.elements.fullName.value);
    const [firstName,...rest] = fullName.split(' ');
    const input = {firstName,lastName:rest.join(' ')};
    action(profileForm, async () => { await api.updateProfile(input); savedName = input; profileForm.elements.fullName.value = fullName; updateNameSave(); q('[data-account-greeting]').textContent = input.firstName ? text('welcome_named_html', {name:input.firstName}) : text('welcome_html'); return profileForm.elements.fullName; }, text('details_saved_html'));
  });
  q('[data-account-marketing]').addEventListener('click', event => {
    const next = marketingState !== 'SUBSCRIBED' && marketingState !== 'PENDING';
    action(event.currentTarget, async () => {
      const result = await api.setMarketing(next); renderMarketing(result.marketingState);
    }, text('marketing_saved_html'));
  });
  q('[data-account-more-orders]').addEventListener('click', event => action(event.currentTarget, () => loadOrders(true)));
  q('[data-account-more-addresses]').addEventListener('click', event => action(event.currentTarget, () => loadAddresses(true)));
  q('[data-account-shop]').addEventListener('click', event => action(event.currentTarget, () => api.login()));
  q('[data-account-email-form]').addEventListener('submit', event => { event.preventDefault(); const email = event.currentTarget.elements.email.value.trim(); action(event.currentTarget, () => api.login(email)); });
  function startSignIn() {
    return action(root, async () => {
      q('[data-account-sign-in-retry]').hidden = true;
      q('[data-account-transition-status]').textContent = text('opening_sign_in_html');
      q('[data-account-transition-status]').hidden = false;
      await api.login();
    });
  }
  q('[data-account-sign-in-retry]').addEventListener('click', startSignIn);
  q('[data-account-logout]').addEventListener('click', event => action(event.currentTarget, async () => { signedOut(); await api.logout(); }));
  async function init() {
    if (designPreview) {
      q('[data-account-transition]').hidden = true;
      q('[data-account-login]').hidden = false;
    }
    const search = window.__pgAccountCallback || location.search;
    delete window.__pgAccountCallback;
    const params = new URLSearchParams(search);
    if (params.has('code') || params.has('error') || api.isSignedIn()) await action(root, async () => {
      if (params.has('code') || params.has('error')) {
        q('[data-account-transition-status]').textContent = text('completing_sign_in_html');
        history.replaceState(null, '', location.pathname + location.hash);
        const returnHash = await api.callback(search);
        if (/^#(?:orders|details|order\/.*)$/.test(returnHash || '')) history.replaceState(null, '', location.pathname + returnHash);
      }
      if (api.isSignedIn()) await loadAccount();
    });
    else if (!designPreview) await startSignIn();
  }
  init().catch(fail);
})();
